import { get, put, post, del } from '../../../../GlobalModules/Utility/Http'
import { mapBookings, mapBookingDetail } from '../Model/BookingEventsModel'

export const getBookingsApi = async (filters = {}) => {
  const queryParams = {}
  const filtersObj = {
    limit: filters.limit || 10,
    offset: filters.offset || 0
  }

  // Add store_id filter if provided
  if (filters.store_id) {
    filtersObj.store_id = filters.store_id
  }

  if (filters.search && filters.search !== '') {
    queryParams.filter_op = JSON.stringify({ search_attr: 'substring' })
    filtersObj.search_attr = filters.search
  }

  // Add sorting if provided
  if (filters.sort && filters.sort.length > 0) {
    filtersObj.sort = [
      {
        field: filters.sort[0].field,
        sort: filters.sort[0].sort
      }
    ]
  } else {
    // Default sorting
    filtersObj.sort = [
      {
        field: 'id',
        sort: 'desc'
      }
    ]
  }

  queryParams.filters = JSON.stringify(filtersObj)
  const response = await get(`${process.env.EXTENDED_URL}booking`, queryParams)
  return mapBookings(response)
}

export const getBookingDetailApi = async (slack) => {
  console.log('getBookingDetailApi called with slack:', slack)
  const response = await get(`${process.env.EXTENDED_URL}booking/${slack}`)
  console.log('getBookingDetailApi response:', response)
  return mapBookingDetail(response)
}

export const updateBookingApi = async (slack, data) => {
  const response = await put(
    `${process.env.EXTENDED_URL}booking/${slack}`,
    data
  )
  return (
    response?.data || { success: false, message: 'Failed to update booking' }
  )
}

export const createBookingApi = async (data) => {
  // Add store_id to the payload if not already present
  const payload = {
    ...data,
    store_id: data.store_id || localStorage.getItem('store_id')
  }
  const response = await post(`${process.env.EXTENDED_URL}booking`, payload)
  return (
    response?.data || { success: false, message: 'Failed to create booking' }
  )
}

export const deleteBookingApi = async (slack) => {
  const response = await del(`${process.env.EXTENDED_URL}booking/${slack}`)
  return (
    response?.data || { success: false, message: 'Failed to delete booking' }
  )
}
